import React from 'react';
import { useFreight } from 'useStores/useFreight';
import UsersDialog from 'components/Dialog/UsersDialog/UsersDialog';

const FreightsModal = ({
  openFreightsModal,
  handleSelectFreight,
  handleCloseOperatorDialog,
}) => {
  return (
    <UsersDialog
      single
      placeholder={'انتخاب باربری:'}
      role={['freight']}
      onChange={handleSelectFreight}
      open={openFreightsModal}
      closeDialog={handleCloseOperatorDialog}
    />
  );
};

export default FreightsModal;
